import { forwardRef, type HTMLAttributes, type ReactNode } from "react";

export type AlertVariant = "info" | "success" | "warning" | "danger";

export type AlertProps = Omit<HTMLAttributes<HTMLDivElement>, "title"> & {
  variant: AlertVariant;
  title?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
};

const VARIANT_CLASSES: Record<AlertVariant, string> = {
  info: "bg-[var(--fz-alert-info-bg)] text-[var(--fz-alert-info-text)] border-[var(--fz-alert-info-border)]",
  success: "bg-[var(--fz-alert-success-bg)] text-[var(--fz-alert-success-text)] border-[var(--fz-alert-success-border)]",
  warning: "bg-[var(--fz-alert-warning-bg)] text-[var(--fz-alert-warning-text)] border-[var(--fz-alert-warning-border)]",
  danger: "bg-[var(--fz-alert-danger-bg)] text-[var(--fz-alert-danger-text)] border-[var(--fz-alert-danger-border)]",
};

export const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  { action, children, className = "", icon, title, variant, ...props },
  ref,
) {
  return (
    <div
      {...props}
      ref={ref}
      data-fz-alert={variant}
      className={`flex items-start gap-3 rounded-[var(--fz-radius)] border px-4 py-3 text-sm ${VARIANT_CLASSES[variant]} ${className}`}
    >
      {icon ? <span className="mt-0.5 shrink-0">{icon}</span> : null}
      <div className="min-w-0 flex-1">
        {title ? <p className="font-semibold">{title}</p> : null}
        <div>{children}</div>
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
});
